import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function AboutUs() { 
  useEffect(() => {
    document.title = 'History -  Mercy Memorial School, Kanpur';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>About Us</li>
                <li>History</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">History</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
                    <p><b>Responding to a decade's pressing demand for an English-medium institution in Kidwai Nagar, Kanpur, Mrs. Sophie Shukla, under the aegis of the Huddard Junior High School Society, established this institution in memory of her worthy sister, Ms. Mercy Roberts, in 1983.</b></p> 
                    <p> In its first month, the school admitted around <b>500</b> children.  With the rising demand for admissions, the management increased the number of sections,  bringing the total to nearly <b> 4000</b>  students today enrolled in  classes playgoup to class XII </p> 
                    <p> The management succeeded in getting the school affiliated with the Council for the Indian School Certificate Examinations in <b>January 1990</b>.</p> 
                    <p>The extraordinary mission left behind by <b>Mrs. Sophie Shukla in 1985 </b> is carried on by her dedicated daughter, Miss Rajni Shukla, who has taken the school to greater heights. Today, the school is quite renowned.</p> 
                    <p>Late Mr. V. J. Abraham, the first principal of this prestigious school, shaped its destiny, which will go down in the annals of Kanpur's history.</p>
              </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default AboutUs;
